<template>
  <v-expand-transition>
    <div
      v-if="(drawer || $vuetify.breakpoint.xlOnly)"
      :class="$vuetify.breakpoint.lgAndDown ? 'drawer' : ''"
    >
      <v-card
        width="500"
        tile
        flat
        :color="$vuetify.breakpoint.xlOnly ? 'transparent' : 'white'"
        max-width="98vw"
        max-height="calc(100vh - 172px)"
      >
        <v-btn
          v-if="!$vuetify.breakpoint.xlOnly"
          absolute
          right
          top
          icon
          text
          @click="drawer = false"
          class="mt-n2"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="fw500 mb-3">
          {{ localStorage.translations.pages.common.text.settings_to_save_pdf }}
        </div>
        <v-checkbox
          v-model="checkAll"
          :label="localStorage.translations.pages.common.text.to_all"
          hide-details
          class="check"
          :indeterminate="indeterminate"
          @change="changeCheckbox"
        />
        <div class="mt-3">
          <div v-for="(block, b) in checkbox" :key="b">
            <div v-if="Object.keys(block).length > 0" class="border mb-2 pa-3">
              <div v-for="(check, cb) in block" :key="cb">
                <v-checkbox
                  v-model="check.value"
                  :label="check.label"
                  :true-value="false"
                  :false-value="true"
                  hide-details
                  class="check"
                  @change="isIndeterminate"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndDown" class="text-end">
          <BaseButton
            @click="drawer = !drawer"
            :text="localStorage.translations.pages.common.buttons.close"
          />
        </div>
      </v-card>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'PersonalAreaCheckboxList',
  props: {
    checkbox: Object,
  },
  data: () => ({
    drawer: false,
    checkAll: true,
    indeterminate: false,
  }),
  computed: {},
  methods: {
    changeCheckbox(data) {
      for (let j in this.checkbox) {
        for (let i in this.checkbox[j]) {
          this.checkbox[j][i].value = !data
        }
      }
      this.isIndeterminate()
    },
    isIndeterminate() {
      this.indeterminate = false
      let temp = false
      if (this.checkbox.block1.photo) {
        temp = this.checkbox.block1.photo.value
      }
      for (let j in this.checkbox) {
        for (let i in this.checkbox[j]) {
          if (this.checkbox[j][i].value !== temp) {
            this.indeterminate = true
          }
        }
      }
      this.$emit('changeCheckbox', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer {
  position: fixed;
  top: 170px;
  left: 2%;
  //overflow-y: scroll;
  z-index: 50;
  overflow: hidden;

  .v-card {
    overflow-y: scroll;
    margin-right: -12px;
    padding: 20px;
  }
}

.border {
  border: 1px solid #bedbeb;
  border-radius: 4px;
}
</style>
